import * as api from '../utils/api'

import {
  setTodaysInventory,
  updateInventoryForVariant,
} from '../store/actions/todays-inventory'

export const fetchInventory = (storeId) => async (dispatch) => {
  console.log(`Fetching today's inventory for store ${storeId}`)
  const { data } = await api.GET(`/p4/stores/${storeId}/inventory`)
  return dispatch(setTodaysInventory(storeId, data))
}

export const adjustInventory =
  (storeId, variantId, amount) => async (dispatch) => {
    return dispatch(
      updateInventory(storeId, variantId, { adjust_quantity: amount }),
    )
  }

export const markDoNotSell =
  (storeId, variantId, doNotSell) => async (dispatch) => {
    return dispatch(
      updateInventory(storeId, variantId, { do_not_sell: doNotSell }),
    )
  }

export const setQuantity =
  (storeId, variantId, quantity) => async (dispatch) => {
    return dispatch(
      updateInventory(storeId, variantId, { quantity_available: quantity }),
    )
  }

export const updateInventory =
  (storeId, variantId, data) => async (dispatch) => {
    console.log(`Updating inventory with data ${JSON.stringify(data)}`)
    const { data: inventory } = await api.PATCH(
      `/p4/stores/${storeId}/inventory/${variantId}`,
      data,
    )
    return dispatch(updateInventoryForVariant(storeId, variantId, inventory))
  }
